export function ScrollRollTop() {
  return (
    <div className="h-5 relative overflow-hidden">
      <div className="absolute inset-0 bg-gradient-to-b from-amber-900/40 to-amber-950/20" />
      <div className="absolute bottom-0 left-0 right-0 h-3 bg-gradient-to-b from-transparent to-[#1a1408]" />
      <div className="absolute inset-0" style={{ background: 'repeating-linear-gradient(90deg, transparent, transparent 4px, rgba(120,80,20,0.1) 4px, rgba(120,80,20,0.1) 5px)' }} />
    </div>
  );
}

export function ScrollRollBottom() {
  return (
    <div className="h-5 relative overflow-hidden">
      <div className="absolute top-0 left-0 right-0 h-3 bg-gradient-to-t from-transparent to-[#0a0805]" />
      <div className="absolute inset-0 bg-gradient-to-t from-amber-900/40 to-amber-950/20" />
      <div className="absolute inset-0" style={{ background: 'repeating-linear-gradient(90deg, transparent, transparent 4px, rgba(120,80,20,0.1) 4px, rgba(120,80,20,0.1) 5px)' }} />
    </div>
  );
}
